import { Form } from "formik";
import React from "react";
import * as yup from "yup";

import Button from "@/components/UI/Button";
import { CustomForm } from "@/component-library/CustomForm";
import FormikInput from "@/components/UI/FormikInput";
import { mergeObjectOnlyExistingFields } from "@/utils/objectUtils";
import { STATES } from "@/constants/states";

import { COMPLETE_PROFILE_STEPS } from "./CompleteProfileWidget";

export const CompleteProfileAddress = (props) => {
  const { profile, setCurrentCompleteProfileStep, submitHandler } = props;

  const renderForm = (formikProps) => {
    const formikInputProps = {
      errors: formikProps.errors,
      touched: formikProps.touched,
    };

    return (
      <Form>
        <div className="mx-auto px-0 mb-3">
          <div className="px-0 row pb-5">
            <>
              <div className="col-12">
                <FormikInput
                  key="address.street"
                  {...formikInputProps}
                  formEl={{
                    elementConfig: {
                      label: "Street Address",
                      placeholder: "Enter Street Address",
                      type: "text",
                    },
                    elementType: "input",
                    name: "address.street",
                  }}
                />
              </div>

              <div className="col-12 col-lg-6">
                <FormikInput
                  key="address.city"
                  {...formikInputProps}
                  formEl={{
                    elementConfig: {
                      label: "City",
                      placeholder: "Enter City",
                      type: "text",
                    },
                    elementType: "input",
                    name: "address.city",
                  }}
                />
              </div>

              <div className="col-12 col-lg-6">
                <FormikInput
                  key="address.state"
                  {...formikInputProps}
                  formEl={{
                    elementConfig: {
                      label: "State",
                      options: STATES,
                      placeholder: "Enter State",
                    },
                    elementType: "select",
                    name: "address.state",
                  }}
                />
              </div>

              <div className="col-6">
                <FormikInput
                  key="address.zip_code"
                  {...formikInputProps}
                  formEl={{
                    elementConfig: {
                      label: "Zip",
                      placeholder: "Enter Zip",
                      type: "text",
                    },
                    elementType: "input",
                    name: "address.zip_code",
                  }}
                />
              </div>
            </>
          </div>
          <div className="px-0 row">
            <div className="col text-center">
              <Button className="Btn Btn--pri self-signup-btn" type="submit">
                Save & Continue
              </Button>
            </div>
          </div>
        </div>
      </Form>
    );
  };

  return (
    <>
      <CustomForm
        initialValues={mergeObjectOnlyExistingFields(ADDRESS_INITIAL_VALUES, profile)}
        onSubmit={(formData, actions) => {
          submitHandler(formData, actions);
          setCurrentCompleteProfileStep(COMPLETE_PROFILE_STEPS.EMERGENCY_CONTACT);
        }}
        render={renderForm}
        validationSchema={addressValidationSchema}
      />
    </>
  );
};

const ADDRESS_INITIAL_VALUES = {
  address: {
    city: "",
    state: "",
    street: "",
    zip_code: "",
  },
  username: "",
};

const addressValidationSchema = yup.object().shape({
  address: yup.object().shape({
    city: yup
      .string()
      .required("City is required")
      .matches(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/, "Enter a valid city")
      .nullable(),
    state: yup.string().required("State is required").nullable(),
    street: yup.string().trim().required("Street is required"),
    zip_code: yup
      .string()
      .required("Zip code is required")
      .matches(/^\d{5}(?:[-\s]\d{4})?$/, "Enter a valid zip code")
      .nullable(),
  }),
});
